import { WppIconCross, WppIconSearch, WppInput } from '@wppopen/components-library-react'
import { InputChangeEventDetail, WppInputCustomEvent } from '@wppopen/components-library/dist/types/components'
import clsx from 'clsx'
import { Dispatch, SetStateAction } from 'react'

interface CustomSearchProps {
  handle: string
  searchTermState: [string, Dispatch<SetStateAction<string>>]
  className?: string
}

const CustomSearch = ({ handle, searchTermState, className }: CustomSearchProps) => {
  const [searchTerm, setSearchTerm] = searchTermState

  const handleSearchChange = (e: WppInputCustomEvent<InputChangeEventDetail>) => {
    const value = e.target.value
    setSearchTerm(value)
  }

  const handleCancel = () => {
    setSearchTerm('')
  }

  return (
    <WppInput
      name={handle}
      className={clsx(className)}
      required
      value={searchTerm}
      placeholder="Start typing ..."
      onWppChange={handleSearchChange}
      data-testid={`${handle}-input`}
      type="text"
    >
      {!!searchTerm && <WppIconCross slot="icon-end" onClick={handleCancel} />} <WppIconSearch slot="icon-start" />{' '}
    </WppInput>
  )
}

export default CustomSearch
